<template>
    <el-button :class="[route.query.id === '782kzq4m' ? '!bg-none !bg-#F5BD4F !b-#F5BD4F' : '']" type="primary"
        class="!rounded-4" @click="login">{{
            t('common.login') }}</el-button>
</template>
<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { setItem } from '@/utils/localstorage';
import { LOCALE_BEFORE_LOGIN_KEY } from '@/store/locale';

const { t } = useI18n();
const router = useRouter();
const route = useRoute();
const { getCurrentLocale } = useStore('locale');
interface Props {
    isChangeStyle?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    isChangeStyle: undefined,
});

const login = () => {
    // 保存当前页面 URL，登录成功后返回（与 ContestCard、api 等保持一致）
    if (!location.pathname.endsWith('/login')) {
        setItem(LOCALE_BEFORE_LOGIN_KEY, getCurrentLocale.value);
    }
    router.push({ path: '/login', query: { redirect_url: encodeURIComponent(location.href) } });
};
</script>
